import React from "react";
import IntlMessages from "util/IntlMessages";
import { Tabs } from "../../../BP2Components";
import TabPane from "../../../BP2Components/Tabs/TabPane";
import GlobalSettings from "../GlobalSettings/GlobalSettingsModal";
import CircleChartSettings from "./CircleChartSettings";

const SettingsChartIndex = (props) => {
   return (
      <Tabs defaultActiveKey="1">
         <TabPane tab={<IntlMessages id="settings.globalSettings" />} key="1">
            <GlobalSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.widgetSettings" />} key="2">
            <CircleChartSettings {...props} />
         </TabPane>
      </Tabs>
   );
};
export default SettingsChartIndex;
